import { HttpClient, HttpEvent, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { TaxTableModalModel } from 'src/app/models/tables/wallet/tax-table-modal.model';
import { environment } from './../../../environments/environment';
import { InvoicingModelDetailModel } from './../../models/invoicing/invoicing-model-detail.model';
import { InvoicingModelDetailImport } from 'src/app/models/imports/invoicing-model-import.model';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';

@Injectable({
  providedIn: 'root'
})
export class InvoicingModelDetailService {

  constructor(private _httpClient: HttpClient) { }

  createInvoicingModelDetail(invoicingModelDetailContract: InvoicingModelDetailModel): Observable<InvoicingModelDetailModel> {
    return this._httpClient.post<InvoicingModelDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingModelDetail.CreateInvoicingModelDetail}`,
      invoicingModelDetailContract);
  }

  createPurchaseModelDetail(invoicingModelDetailContract: InvoicingModelDetailModel): Observable<InvoicingModelDetailModel> {
    return this._httpClient.post<InvoicingModelDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingModelDetail.CreatePurchaseModelDetailAsync}`,
      invoicingModelDetailContract);
  }

  createInvoicingModelDetails(invoicingModelDetails: { invoicingModelId: number; invoicingModelDetailId: number; }[]): Observable<boolean> {
    return this._httpClient.post<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingModelDetail.CreateDetails}`, invoicingModelDetails);
  }

  deleteSomeDetails(invoicingModelDetailIds: Array<number>): Observable<boolean> {
    return this._httpClient.put<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingModelDetail.DeleteSomeDetails}`,
      invoicingModelDetailIds);
  }

  downloadPurchaseGuideImport(): Observable<HttpEvent<Blob>> {
    return this._httpClient.request(new HttpRequest('GET', `${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingModelDetail.DownloadPurchaseGuideImport}`,
      null, { reportProgress: true, responseType: 'blob' })
    );
  }

  downloadGuideImport(): Observable<HttpEvent<Blob>> {
    return this._httpClient.request(new HttpRequest('GET', `${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingModelDetail.DownloadGuideImport}`,
      null, { reportProgress: true, responseType: 'blob' })
    );
  }

  exportDetailConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingModelDetail.ExportDetailConsultation}`, filters, {
      params, responseType: 'blob',
    });
  }

  getAllInvoicingModelDetailsWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingModelDetail.GetAllInvoicingModelDetailsWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getAllPurchaseModelDetailsWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingModelDetail.GetAllPurchaseModelDetailsWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getColumnsForCaptureTable(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingModelDetail.GetColumnsForCaptureTableAsync}`);
  }

  getColumnsForCaptureTablePurchaseConceptAsync(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingModelDetail.GetColumnsForCaptureTablePurchaseConceptAsync}`);
  }

  getColumnsForTaxes(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingModelDetail.GetColumnsForTaxesAsync}`);
  }

  getColumnsForDetailConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingModelDetail.GetColumnsForDetailConsultationAsync}`);
  }

  getColumnsForPurchaseDetailConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingModelDetail.GetColumnsForPurchaseDetailConsultationAsync}`);
  }

  getColumnsInvoicingModelDetailAsync(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingModelDetail.GetColumnsInvoicingModelDetailAsync}`);
  }

  getColumnsPurchaseModelDetailAsync(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingModelDetail.GetColumnsPurchaseModelDetailAsync}`);
  }

  getInvoicingModelDetailById(invoicingModelDetailId: number): Observable<InvoicingModelDetailModel> {
    return this._httpClient.get<InvoicingModelDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingModelDetail.GetInvoicingModelDetailById}/${invoicingModelDetailId}`);
  }

  getInvoicingModelDetailByIdForSelectionAsync(invoicingModelId: number, page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('invoicingModelId', invoicingModelId).set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingModelDetail.GetInvoicingModelDetailByIdForSelectionAsync}`,
      filters, { params: params }
    );
  }

  getPurchaseModelDetailByIdForSelectionAsync(invoicingModelId: number, page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('invoicingModelId', invoicingModelId).set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingModelDetail.GetPurchaseModelDetailByIdForSelectionAsync}`,
      filters, { params: params }
    );
  }

  getInvoicingModelDetailByKeys(invoicingModelId: number, conceptInvoicingId: number, invoicingModelDetailContract: InvoicingModelDetailModel): Observable<InvoicingModelDetailModel> {
    return this._httpClient.post<InvoicingModelDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingModelDetail.GetInvoicingModelDetailByKeys}/${invoicingModelId}/${conceptInvoicingId}`, invoicingModelDetailContract);
  }

  getInvoicingModelDetailsForCaptureTable(page: number, limit: number, columnSort: string | null, ascendant: boolean, invoicingModelId: number): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '')
      .set('ascendant', ascendant).set('invoicingModelId', invoicingModelId);
    return this._httpClient.get<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingModelDetail.GetInvoicingModelDetailsForCaptureTableAsync}`,
      { params: params }
    );
  }

  getPurchaseModelDetailsForCaptureTableAsync(page: number, limit: number, columnSort: string | null, ascendant: boolean, invoicingModelId: number): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '')
      .set('ascendant', ascendant).set('invoicingModelId', invoicingModelId);
    return this._httpClient.get<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingModelDetail.GetPurchaseModelDetailsForCaptureTableAsync}`,
      { params: params }
    );
  }

  getInvoicingModelDetailsByModel(invoicingModelId: number): Observable<Array<InvoicingModelDetailModel>> {
    return this._httpClient.get<Array<InvoicingModelDetailModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingModelDetail.GetInvoicingModelDetailsByModel}/${invoicingModelId}`);
  }

  getTaxesForDetailsAsync(isIva: boolean, page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<TaxTableModalModel>> {
    const params = new HttpParams().set('isIva', isIva).set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<TaxTableModalModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingModelDetail.GetTaxesForDetailsAsync}`,
      filters, { params: params }
    );
  }

  importInvoicingModelDetail(orderImports: Array<InvoicingModelDetailImport>): Observable<LoadPreInvoicingModel> {
    return this._httpClient.post<LoadPreInvoicingModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingModelDetail.ImportInvoicingModelDetailsAsync}`,
      orderImports
    );
  }

  importPurchaseModelDetail(orderImports: Array<InvoicingModelDetailImport>): Observable<LoadPreInvoicingModel> {
    return this._httpClient.post<LoadPreInvoicingModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingModelDetail.ImportPurchaseModelDetailsAsync}`,
      orderImports
    );
  }

  updateInvoicingModelDetail(invoicingModelDetailContract: InvoicingModelDetailModel): Observable<InvoicingModelDetailModel> {
    return this._httpClient.put<InvoicingModelDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingModelDetail.UpdateInvoicingModelDetail}`,
      invoicingModelDetailContract);
  }

  updatePurchaseModelDetail(invoicingModelDetailContract: InvoicingModelDetailModel): Observable<InvoicingModelDetailModel> {
    return this._httpClient.put<InvoicingModelDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingModelDetail.UpdatePurchaseModelDetail}`,
      invoicingModelDetailContract);
  }

}
